// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer__wj1tb {
  display: flex;
  align-items: center;
  flex-direction: column;
  grid-template-columns: 1fr;
  row-gap: 30px;
  padding: 0 30px;
}

.inputContainer__PDGwn {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.scopeNotesMainContainer__QBHqB {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 2px;
}

.titleInputMainContainer__AHtRh {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.scopeContainer__oCLNY {
  display: flex;
}

.notesContainer__otMVg {
  display: flex;
  justify-content: center;
}

.textArea__Yhnge {
  display: flex;
  font-family: 'Helvetica Neue', sans-serif;
  box-sizing: border-box;
  padding: 8px;
  font-size: 14px;
  font-weight: 300;
  border-radius: 0 0 10px 10px;
  outline: none;
  width: 100%;
  resize: none;
}

.conditionsContainer__KIIVh {
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 50px;
}

.title__W2Qiv {
  display: flex;
  margin-right: 8px;
}

.conditionInput__obr9h {
  width: 50px;
  border: 1px solid var(--border-blue);
  border-radius: 5px;
  padding: 0 10px;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 16px;
  height: 30px;
}

.column__jLac6 {
  display: flex;
}

.textInputs__PYQau {
  display: grid;
  grid-template-columns: auto auto;
  justify-items: center;
  width: 100%;
  gap: 13px;
}

.text__WqCct {
  display: flex;
  padding-right: 10px;
  width: 104px;
}

.statusContainer__fHy2C {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: flex-start;
  margin-left: 55px;
}

.inputContainerDos__kwahF {
  display: flex;
}

.textDos__QQLcV {
  display: flex;
  width: 145px;
  padding-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/design-details/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".mainContainer {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  grid-template-columns: 1fr;\n  row-gap: 30px;\n  padding: 0 30px;\n}\n\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.scopeNotesMainContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  row-gap: 2px;\n}\n\n.titleInputMainContainer {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.scopeContainer {\n  display: flex;\n}\n\n.notesContainer {\n  display: flex;\n  justify-content: center;\n}\n\n.textArea {\n  display: flex;\n  font-family: 'Helvetica Neue', sans-serif;\n  box-sizing: border-box;\n  padding: 8px;\n  font-size: 14px;\n  font-weight: 300;\n  border-radius: 0 0 10px 10px;\n  outline: none;\n  width: 100%;\n  resize: none;\n}\n\n.conditionsContainer {\n  display: grid;\n  grid-template-columns: auto auto auto;\n  gap: 50px;\n}\n\n.title {\n  display: flex;\n  margin-right: 8px;\n}\n\n.conditionInput {\n  width: 50px;\n  border: 1px solid var(--border-blue);\n  border-radius: 5px;\n  padding: 0 10px;\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 16px;\n  height: 30px;\n}\n\n.column {\n  display: flex;\n}\n\n.textInputs {\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-items: center;\n  width: 100%;\n  gap: 13px;\n}\n\n.text {\n  display: flex;\n  padding-right: 10px;\n  width: 104px;\n}\n\n.statusContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-self: flex-start;\n  margin-left: 55px;\n}\n\n.inputContainerDos {\n  display: flex;\n}\n\n.textDos {\n  display: flex;\n  width: 145px;\n  padding-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `mainContainer__wj1tb`,
	"inputContainer": `inputContainer__PDGwn`,
	"scopeNotesMainContainer": `scopeNotesMainContainer__QBHqB`,
	"titleInputMainContainer": `titleInputMainContainer__AHtRh`,
	"scopeContainer": `scopeContainer__oCLNY`,
	"notesContainer": `notesContainer__otMVg`,
	"textArea": `textArea__Yhnge`,
	"conditionsContainer": `conditionsContainer__KIIVh`,
	"title": `title__W2Qiv`,
	"conditionInput": `conditionInput__obr9h`,
	"column": `column__jLac6`,
	"textInputs": `textInputs__PYQau`,
	"text": `text__WqCct`,
	"statusContainer": `statusContainer__fHy2C`,
	"inputContainerDos": `inputContainerDos__kwahF`,
	"textDos": `textDos__QQLcV`
};
export default ___CSS_LOADER_EXPORT___;
